"use client";
import { toWebp } from "@/utils/common";
import Image from "next/image";
import { useEffect, useState } from "react";

interface StatCardProps {
  data?: any; // single impect_card object
}

const StatCard = ({ data }: StatCardProps) => {
  const [bg, setBg] = useState("/images/mobile.jpg");
  const [position, setPosition] = useState("100%");

  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

  const desktopBg = data?.image?.data?.attributes?.url
    ? toWebp(`${baseUrl}${data.image.data.attributes.url}`)
    : "/images/about/w1.png";

  const mobileBg = data?.mobile_image?.data?.attributes?.url
    ? toWebp(`${baseUrl}${data.mobile_image.data.attributes.url}`)
    : "/images/about/w-mobile.png";

  useEffect(() => {
    const updateBg = () => {
      if (window.innerWidth > 1024) {
        setBg(desktopBg);
      } else if (window.innerWidth >= 768) {
        setBg(desktopBg);
        setPosition("150%");
      } else if (window.innerWidth >= 430) {
        setBg(mobileBg);
        setPosition("top");
      } else if (window.innerWidth >= 375) {
        setBg(mobileBg);
        setPosition("top");
      } else {
        setBg(mobileBg);
        setPosition("top");
      }
    };

    updateBg();
    window.addEventListener("resize", updateBg);
    return () => window.removeEventListener("resize", updateBg);
  }, [desktopBg, mobileBg]);

  return (
    <div
      className={`
        bg-white relative
        xl:p-[70px_32px] sm:p-[80px_32px] p-[288px_24px_24px_24px]
        flex flex-col w-[100%] sm:h-[407px]
        border-blue-100 border-1
        bg-top xl:bg-contain sm: bg-no-repeat
        sm:bg-[65%] xl:bg-right
      `}
      style={{
        backgroundImage: `url(${bg})`,
        backgroundPosition: position,
      }}
    >
      <div className="flex flex-col justify-between w-full">
        <h2 className="text-heading-2 text-primary-text font-bold sm:mb-[32px] mb-[24px] text-left">
          {data?.title}
        </h2>

        <div
          className="
          flex 
          flex-col gap-3 
          sm:flex-col   /* Mobile + Tablet: stacked vertically */
          xl:flex-wrap  /* Desktop: wrap in rows */
          xl:flex-row 
          max-w-full lg:max-w-[560px] 
          ml-0 mr-auto relative z-10
        "
        >
          {data?.tags?.map((tag: any, index: number) => (
            <div
              key={tag?.id || index}
              className="flex items-center mr-3 mb-3 lg:mb-0"
            >
              {/* Icon box */}
              {tag?.Image?.data?.attributes?.url && (
                <div
                  className={`${
                    index === 1 ? "bg-green-50" : "bg-blue-50"
                  } h-[48px] w-[48px] flex items-center justify-center`}
                >
                  {tag?.Image?.data?.attributes?.url && (
                    <Image
                      src={baseUrl + tag?.Image?.data?.attributes.url}
                      height={24}
                      width={24}
                      alt={tag?.title || "tag-icon"}
                    />
                  )}
                </div>
              )}

              {/* Text box */}
              <span
                className={`font-semibold text-secondary-text text-subtitle-2 flex items-center h-[48px] px-3 border ${
                  index === 1 ? "border-green-100" : "border-blue-100"
                } bg-white`}
              >
                {tag?.title}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatCard;
